import React from 'react';

interface TextareaProps {
  label?: string;
  name?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  disabled?: boolean;
  error?: string;
  className?: string;
  required?: boolean;
  maxLength?: number;
  showCount?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  rows = 4,
  disabled = false,
  error,
  className = '',
  required = false,
  maxLength,
  showCount = false,
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-text">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <textarea
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        rows={rows}
        maxLength={maxLength}
        className={`w-full px-3 py-2 bg-shell border border-line rounded-lg text-text placeholder-muted transition-all duration-200 hover:border-chart/30 focus:outline-none focus:ring-2 focus:ring-chart/30 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed resize-vertical ${
          error ? 'border-danger' : ''
        }`}
      />
      <div className="flex items-center justify-between gap-2 -mt-1">
        {error
          ? <p className="text-sm text-danger">{error}</p>
          : <span />}
        {showCount && typeof maxLength === 'number' && (
          <span className="text-xs text-muted">{(value || '').length} / {maxLength}</span>
        )}
      </div>
    </div>
  );
};

export default Textarea;
